/**
 * [TEMPORARY] STORAGE_PRIMARY organization용 RMS API baseURL 오버라이드를 위한 store
 * - 특정 organization(ArrowPoint, CGSI 등)은 staging에서도 production RMS API를 사용
 * - 해당 기능이 더 이상 필요 없으면 이 파일과 관련 코드를 삭제할 것
 * - 관련 파일: src/api/rms_v2_processing/config.ts, src/hooks/useAuth.ts
 */
import { create } from 'zustand'

interface UserState {
  organizationId: string | null
  setOrganizationId: (id: string | null) => void
}

export const useUserStore = create<UserState>((set) => ({
  organizationId: null,
  setOrganizationId: (id) => set({ organizationId: id }),
}))

// Non-hook access for axios interceptor
export const getUserOrganizationId = () => useUserStore.getState().organizationId
